import React, { useEffect } from 'react';

import { CrossIcon } from '@/assets/icons';
import { sendCustomAnalyticsEvent } from '@/utils/AnalyticsUtils';
import { NOTIFICATION_BAR_SHOWN, TEST_IDS } from '@/constants';

import styles from './NotificationBar.module.scss';

export interface INotificationBarProps {
	notification: {
		title: string;
		dismissible?: boolean;
	};
	onClose: () => void;
}

const NotificationBar = ({ notification, onClose }: INotificationBarProps) => {
	useEffect(() => {
		const eventObj = {
			name: NOTIFICATION_BAR_SHOWN,
		};

		sendCustomAnalyticsEvent('custom', eventObj);
	}, []);

	return (
		<div
			data-id={TEST_IDS.MERCHANT_ANNOUNCEMENT_BAR.CONTAINER}
			className={styles.container}
		>
			<div className={styles.textWrapper}>{notification.title}</div>
			{notification.dismissible && (
				<CrossIcon
					data-id={TEST_IDS.MERCHANT_ANNOUNCEMENT_BAR.CLOSE_ICON}
					className={styles.closeIcon}
					onClick={onClose}
				/>
			)}
		</div>
	);
};

export default NotificationBar;
